import React from 'react';
import {FormControl, FormHelperText, InputLabel} from '@material-ui/core';
import PhoneInput, {
  PhoneInputFieldProps
} from '../PhoneInputField/PhoneInputField';
import {useTranslation} from 'react-i18next';
import {INPUT_LABEL_COLOR} from 'src/style/variable';

interface IPhoneInputField extends Omit<PhoneInputFieldProps, 'error'> {
  value: string;
  label: string;
  error?: Record<string, any>;
}
const PhoneInputField = (props: IPhoneInputField): JSX.Element => {
  const {label, error, ...rest} = props;
  const {t} = useTranslation();
  return (
    <FormControl error={!!error} fullWidth={true} variant="standard">
      <InputLabel
        style={{
          position: 'static',
          transform: 'none',
          fontSize: '1.1rem',
          color: INPUT_LABEL_COLOR
        }}
        shrink>
        {label}
      </InputLabel>
      <PhoneInput {...rest} error={!!error} />
      {error && <FormHelperText>{t(error.message)}</FormHelperText>}
    </FormControl>
  );
};

export default PhoneInputField;
